
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable, BehaviorSubject } from "rxjs";


@Injectable({
  providedIn: "root"
})

export class signinsService {

  noAuthHeader = { headers: new HttpHeaders({ "Content-Type": "application/json" }) };
  
  constructor(
    private http: HttpClient,
    private firestore : AngularFirestore
  ) {
    this.firestore.firestore.settings({experimentalForceLongPolling: true});
  }

  //HttpMethods

  getSigninsList() {
    return this.firestore.collection("signins", ref => ref.orderBy('date_created','desc')).snapshotChanges();
  }

  getSignInData(id) { 
    return this.firestore.collection("signins").doc(id).get();
  }


}
